import React, { Component } from 'react';
import { connect } from 'react-redux';
import { change, reduxForm, Field } from 'redux-form';
import { Button, Form, Label, Icon } from 'semantic-ui-react';
import {
  combineValidators,
  composeValidators,
  hasLengthGreaterThan,
  isAlphabetic,
  isRequired,
  matchesPattern
} from 'revalidate';
import PropTypes from 'prop-types';
import TextInput from '../../../app/common/Form/TextInput';
import { updateName, updatedMobileNumber } from '../userActions';
import { openModal } from '../../modals/modalActions';
import API from '../../../APIconfig';

const formName = 'editProfileForm';

const mapState = state => ({
  auth: state.auth,
  async: state.async,
  initialValues: {
    firstName: state.auth && state.auth.profile && state.auth.profile.name && state.auth.profile.name.split(' ')[0],
    lastName: state.auth && state.auth.profile && state.auth.profile.name && state.auth.profile.name.split(' ')[1],
    mobileno: state.auth && state.auth.profile && state.auth.profile.mobileNo
  }
});

const actions = {
  openModal,
  updateName,
  updatedMobileNumber
};

const validate = combineValidators({
  firstName: composeValidators(
    isRequired({ message: 'First Name is required' }),
    hasLengthGreaterThan(3)({ message: 'Minimum length should be 4' }),
    isAlphabetic({ message: 'Only alphabets are allowed' })
  )(),

  lastName: composeValidators(
    isRequired({ message: 'Last Name is required' }),
    hasLengthGreaterThan(2)({ message: 'Minimum length should be 3' }),
    isAlphabetic({ message: 'Only alphabets are allowed' })
  )(),

  mobileno: composeValidators(
    isRequired({ message: 'Mobile number is required' }),
    matchesPattern(/^(\+\d{1,3}[- ]?)?[1-9][0-9]{9}$/)({
      message: 'Invalid mobile number'
    })
  )()
});

class EditProfileForm extends Component {
  static propTypes = {
    auth: PropTypes.object.isRequired,
    async: PropTypes.object.isRequired,
    openModal: PropTypes.func.isRequired,
    updateName: PropTypes.func.isRequired,
    updatedMobileNumber: PropTypes.func.isRequired
  };

  submit = values => {
    const { auth, updateName } = this.props;

    // update name
    updateName(
      values['firstName'],
      values['lastName'],
      auth.csrfRequestIdentifier,
      auth.profile && auth.profile.email,
      auth.profile
    );

    const { openModal, updatedMobileNumber } = this.props;

    if (auth.profile && auth.profile.mobileNo !== values['mobileno']) {
      // update mobile number
      // TODO: This service is not available right now, so disabling this feature on UI.
      const payload = {
        values: { mobileNumber: values['mobileno'], purpose: 'UPDATE_MOBILE' },
        csrfRequestIdentifier: auth.csrfRequestIdentifier,
        forwardAction: updatedMobileNumber,
        api: {
          generate: API.user.sendOTPToMobile,
          verify: API.user.updateMobileNumber
        }
      };

      // Request to open OTP modal
      openModal('OTPModal', { payload });
    }
  };

  componentDidMount() {
    // After submit the form is remounting but not initializing values
    // This explicitly sets the values on mount
    const { dispatch, initialValues: { firstName, lastName, mobileno} } = this.props;

    dispatch(change(formName, 'firstName', firstName));
    dispatch(change(formName, 'lastName', lastName));
    dispatch(change(formName, 'mobileno', mobileno));
  }

  render() {
    const { async, handleSubmit, invalid, pristine } = this.props;
    return (
      <React.Fragment>
        {pristine || invalid ? (
          <Label>
            <Icon name="pencil" /> Please update the form and save changes!
          </Label>
        ) : (
            <Label color="green">
              <Icon name="pencil" /> Ready to submit!
          </Label>
          )}

        <br />
        <br />
        <Form
          onSubmit={handleSubmit(this.submit)}
          loading={async.key === 'updatename' && async.loading}
        >
          <Field
            name="firstName"
            placeholder="First Name"
            type="text"
            component={TextInput}
          />
          <Field
            name="lastName"
            placeholder="Last Name"
            type="text"
            component={TextInput}
          />

          <Field
            name="mobileno"
            placeholder="Mobile number"
            type="text"
            disabled
            component={TextInput}
          />

          <p style={{fontSize: "13px", color: "#9f9f9f", fontStyle: "italic"}}>Update mobile number functionality will be available soon. Stay tuned.</p>

          <Button disabled={invalid || pristine} className="fcbtn fcprimary">
            Save Changes
          </Button>
        </Form>
      </React.Fragment>
    );
  }
}

export default connect(
  mapState,
  actions
)(
  reduxForm({ form: formName, enableReinitialize: true, validate })(
    EditProfileForm
  )
);
